// redux/store.ts
import { configureStore } from '@reduxjs/toolkit';
import userReducer from './slices/userSlice';
import vendorReducer from './slices/vendorSlice';
import shopReducer from './slices/shopSlice';
import userProfileReducer from './slices/userProfileSlice';
import productReducer from './slices/productSlice';
import categoryReducer from './slices/categorySlice';
import cartReducer from './slices/cartSlice';
import orderReducer from './slices/orderSlice';
import authReducer from './slices/authSlice';
import deliveryReducer from './slices/deliverySlice';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    user: userReducer,
    vendor: vendorReducer,
    shop: shopReducer,
    userProfile: userProfileReducer,
    product: productReducer,
    category: categoryReducer,
    cart: cartReducer,
    orders: orderReducer,
    delivery : deliveryReducer,
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
